'use client';

import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from '@headlessui/react';
import { MinusIcon, PlusIcon } from '@heroicons/react/20/solid';

import { tw } from '@repo/ui';

import { faqContent } from '@claim/data/faq-content';

import { BaseLayout } from '../../components/layouts/base-layout';

export default function Page() {
  return (
    <BaseLayout>
      <div className='mx-auto flex w-full max-w-screen-sm justify-center'>
        <div className='flex w-full flex-col gap-2'>
          <div className='mx-auto flex w-full flex-col gap-4 rounded-xl'>
            <h3 className='mb-1 text-2xl font-semibold text-white'>FAQ</h3>
            {faqContent.map((item, index) => (
              <Disclosure
                key={index}
                as='div'
                className={tw(
                  'rounded-3xl bg-white bg-opacity-[.08] p-6 backdrop-blur-xl',
                )}
              >
                <DisclosureButton className='group flex w-full items-center justify-between'>
                  <span
                    className={tw(
                      'text-sm/6 font-medium italic text-white group-data-[hover]:text-white/80',
                    )}
                  >
                    {item.question}
                  </span>
                  <PlusIcon
                    className={tw(
                      'size-5 fill-white/60 group-data-[open]:hidden',
                      'group-data-[hover]:fill-white/50',
                    )}
                  />
                  <MinusIcon
                    className={tw(
                      'hidden size-5 fill-white/60 group-data-[open]:block',
                      'group-data-[hover]:fill-white/50',
                    )}
                  />
                </DisclosureButton>
                <DisclosurePanel
                  transition
                  className={tw(
                    'mt-4 text-sm/5 font-thin italic text-white/40',
                    'origin-top transition duration-200 ease-out',
                    'data-[closed]:-translate-y-6 data-[closed]:opacity-0',
                  )}
                >
                  <p>{item.answer}</p>
                  {item.hasList && (
                    <>
                      {item.isOrderedList ? (
                        <ol className='mt-2 list-decimal pl-4'>
                          {item.listItems?.map((listItem, listIndex) => (
                            <li key={listIndex}>{listItem}</li>
                          ))}
                        </ol>
                      ) : (
                        <ul className='mt-2 list-disc pl-4'>
                          {item.listItems?.map((listItem, listIndex) => (
                            <li key={listIndex}>{listItem}</li>
                          ))}
                        </ul>
                      )}
                    </>
                  )}
                </DisclosurePanel>
              </Disclosure>
            ))}
          </div>
        </div>
      </div>
    </BaseLayout>
  );
}
